import { getMark } from '@atlassian/jira-common-performance/src/marks.tsx';

const getState = () => {
	if (getMark('ssr.spa.state')?.startTime) {
		return 'success';
	}
	if (getMark('ssr.spa.early-common-flush:end')?.startTime) {
		return 'spa-render-failure';
	}

	return 'static-fallback';
};

export const getSSRStateInformation = () => {
	return {
		'ssr:state': getState(),
	};
};
